import { useEffect } from 'react';
import api from '../api/offlineClient';

export default function Prejob() {
  useEffect(() => {
    function onMsg(e) {
      if (!e.data || e.data.type !== 'sgv_doc' || e.data.docType !== 'prejob') return;
      const d = e.data;
      api.post('/api/documents/create', {
        tipo: 'prejob',
        nombre: d.nombre || 'Prejob',
        año: d.fecha ? new Date(d.fecha).getFullYear() : null,
        semana: null,
        total_gastos: 0,
        nota_numero: null,
        file_b64: d.fileB64 || null,
        file_name: d.fileName || 'prejob.html',
      }).catch(() => {});
    }
    window.addEventListener('message', onMsg);
    return () => window.removeEventListener('message', onMsg);
  }, []);

  return (
    <iframe
      src="/prejob.html"
      title="Prejob"
      style={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
    />
  );
}
